const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoSizeSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Border_box",
    "data-name": "Border box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_compound",
    "data-name": "Layer 1 compound"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3.69H2.68C1.57.69.68,1.58.68,2.69v18.62c0,1.1.9,2,2,2h18.63c1.1,0,2-.9,2-2V2.69c0-1.1-.9-2-2-2ZM20.74,20.8H3.18V3.19h17.57v17.62Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "small_video",
    "data-name": "small video",
    x: 7.33,
    y: 5.49,
    width: 9.33,
    height: 6.77,
    rx: 1,
    ry: 1,
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSizeSmall);
export default __webpack_public_path__ + "static/media/video-size-small.fad30c62cecee18117d7e8ba24ea1e64.svg";
export { ForwardRef as ReactComponent };